import React, { useState } from "react";
import {
  Button,
  FormFieldSet,
  LogoLoader,
  PermissionTable,
  showToast,
} from "../../../../../../../components";
import { mapTableRows } from "../../../../../../../utils";
import {
  getAllRoles,
  updateModuleAccess,
} from "../../../../../../../redux/slices/setting/settingApi";

const Ats = () => {
  const [checkedRows, setCheckedRows] = useState({});
  const [checkMultiSelected, setCheckMultiSelected] = useState();
  const [loading, setLoading] = useState(false);
  const [originalModuleAccess, setOriginalModuleAccess] = useState([]);
  const [roleId, setRoleId] = useState(null);
  const [selectedPermissions, setSelectedPermissions] = useState([]);

  const handleCheckboxChange = (rowId, values) => {
    setCheckedRows((prev) => ({
      ...prev,
      [rowId]: values,
    }));
  };

  const columns = [
    {
      key: "features",
      label: "Features",
      render: (row) => <div className="text-info-500">{row?.features}</div>,
    },
    {
      key: "add",
      label: "Add",
      render: (row) => (
        <FormFieldSet
          type="checkbox"
          noTitle
          options={[
            {
              label: "",
              value: "1",
            },
          ]}
          values={checkedRows[row.id] || []}
          onChange={(values) => handleCheckboxChange(row.id, values)}
        />
      ),
    },
  ];
  const ModuleAccess = {
    1: { name: "AtsDashboard" },
    2: { name: "Leads Profile" },
    3: { name: "My Leads" },
    4: { name: "My Team Summary" },
    5: { name: "Daily Production" },
    6: { name: "Bulk Emails" },
    7: { name: "Email Template" },
    8: { name: "Assign" },
    9: { name: "Followup Assign" },
    10: { name: "Prospects" },
    11: { name: "Get Account Details" },
    12: { name: "All Accounts" },
    13: { name: "vendor" },
    14: { name: "All Jobs" },
    15: { name: "Job Details" },
    16: { name: "Draft Jobs" },
    17: { name: "Add New Job Post" },
    18: { name: "Job Baords" },
    19: { name: "Pipeline Candidates" },
    20: { name: "Client Submissions" },
    21: { name: "Followup Interview" },
    22: { name: "Confirmed OrStart" },
    // 23: { name: "Campaigns" },
    // 24: { name: "Internal Sunmissions" },
    // 25: { name: "Interview Follow-up" },
    // 26: { name: "Confirmed/Starts" },
    // 27: { name: "Hotlist" },
    // 28: { name: "Campaign" },
    // 29: { name: "Marketplace" },
    // 30: { name: "Company Profile" },
    // 31: { name: "Configurations" },
    // 32: { name: "Access Control" },
  };

  const featuresList = Array(2)
    .fill(["Lead Profile", "My Leads", "My Team Summary", "Daily Production"])
    .flat();

  // const rows = featuresList.map((feature, i) => ({
  //   id: i + 1,
  //   features: feature,
  // }));
  const rows = Object.entries(ModuleAccess).map(([id, obj]) => ({
    id: Number(id),
    features: obj.name,
  }));

  const mappedRows = mapTableRows(rows, columns);

  const handleRoleChange = async (role) => {
    setCheckMultiSelected(role.label);

    try {
      setLoading(true);
      const response = await getAllRoles({
        coll: "Role",
        fil: {
          name: { type: "NONE", value: role.label },
        },
        ret: "moduleAccess",
      });

      const moduleAccessArray =
        response?.data?.data?.[0]?.moduleAccess.ats || [];
      const id = response?.data?.data?.[0]?._id || null;
      // console.log(moduleAccessArray, "moduleAccessArray");
      setRoleId(id);
      setOriginalModuleAccess(moduleAccessArray);
      const preselectedKeys = extractCheckedKeys(moduleAccessArray);
      // const newChecked = {};
      // rows.forEach((row) => {
      //   if (moduleAccessArray.includes(row.id)) {
      //     newChecked[row.id] = "1";
      //   }
      // });
      // setCheckedRows(newChecked);
      setSelectedPermissions(moduleAccessArray);
      setCheckedRows(preselectedKeys);
    } catch (error) {
      console.error("Failed to fetch role access:", error);
    } finally {
      setLoading(false);
    }
  };

  // const handleSave = async () => {
  //   if (!roleId) {
  //     showToast("RoleId not found", "error", 2000);
  //     return;
  //   }
  //   const currentSelected = Object.keys(checkedRows)
  //     .filter((key) => checkedRows[key]?.includes("1"))
  //     .map(Number);

  //   const added = currentSelected.filter(
  //     (id) => !originalModuleAccess.includes(id)
  //   );
  //   const removed = originalModuleAccess.filter(
  //     (id) => !currentSelected.includes(id)
  //   );
  //   if (added.length === 0 && removed.length === 0) {
  //     showToast("No changes to update", "info", 2000);
  //     return;
  //   }
  //   // const payload = {};
  //   // if (added.length > 0) {
  //   //   payload["$addToSet"] = { moduleAccess: added };
  //   // }
  //   // if (removed.length > 0) {
  //   //   payload["$pull"] = { moduleAccess: { $in: removed } };
  //   // }

  //   // if (Object.keys(payload).length === 0) {
  //   //   showToast("No changes to update","info");
  //   //   return;
  //   // }
  //   const payload = {
  //     $set: { "moduleAccess.ats": currentSelected },
  //   };

  //   try {
  //     setLoading(true);
  //     const res = await updateModuleAccess({ id: roleId, payload });
  //     if (res?.data) {
  //       showToast("Updated successfully", "success", 2000);
  //     } else {
  //       showToast("Error in updating module access", "error", 2000);
  //     }
  //   } catch (error) {
  //     console.error("Failed to update module access:", error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  const handleSave = async () => {
    if (!roleId) {
      showToast("Role not Selected", "error", 2000);
      return;
    }
    const payload = {
      $set: {
        "moduleAccess.ats": selectedPermissions,
      },
    };

    try {
      setLoading(true);
      // console.log("Payload to be sent:", payload);
      const res = await updateModuleAccess({ id: roleId, payload });
      if (res?.data) {
        const refreshed = await getAllRoles({
          coll: "Role",
          fil: { _id: { type: "NONE", value: roleId } },
          ret: "moduleAccess",
        });

        const updatedAccess =
          refreshed?.data?.data?.[0]?.moduleAccess?.ats || [];
        setOriginalModuleAccess(updatedAccess);
        setSelectedPermissions(updatedAccess);

        // Extract keys for PermissionTable
        const preselectedKeys = extractCheckedKeys(updatedAccess);
        setCheckedRows(preselectedKeys);
        showToast("Updated successfully", "success", 2000);
      } else {
        showToast("Error in updating module access", "error", 2000);
      }
    } catch (error) {
      console.error("Failed to update module access:", error);
    } finally {
      setLoading(false);
    }
  };

  const sampleData = [
    {
      name: "Dashboard",
      type: "path",
      path: "ats/dashboard",
      key: "dashboard",
      children: [],
    },
    {
      name: "My Profile",
      type: "path",
      path: "profile",
      key: "profile",
      children: [],
    },
    {
      name: "Leads",
      type: "path",
      key: "leads",
      path: "ats/leads",
      children: [
        {
          name: "Lead Profile",
          type: "tab",
          key: "leads_leadsprofile",
          path: "ats/leads#lead-profile",
          children: [],
        },
        {
          name: "My Leads",
          type: "tab",
          key: "leads_myleads",
          path: "ats/leads#my-leads",
          children: [],
        },
        {
          name: "My Team Summary",
          type: "tab",
          key: "leads_myteamsummary",
          path: "ats/leads#my-team-summary",
          children: [],
        },
        {
          name: "Daily Production",
          type: "tab",
          key: "leads_dailyproduction",
          path: "ats/leads#daily-production",
          children: [],
        },
        {
          name: "All Leads",
          type: "tab",
          key: "leads_allleads",
          path: "ats/leads#all-leads",
          children: [],
        },
        {
          name: "Leads Pending Approvals",
          type: "tab",
          key: "leads_pendingapprovals",
          path: "ats/leads#leads-pending-approvals",
          children: [],
        },
      ],
    },
    {
      name: "Campaigns",
      type: "path",
      key: "campaigns",
      path: "ats/campaigns",
      children: [
        {
          name: "Bulk Emails",
          type: "tab",
          key: "campaigns_bulkemails",
          path: "ats/campaigns#bulk-emails",
          children: [],
        },
        {
          name: "Email Templates",
          type: "tab",
          key: "campaigns_emailtemplates",
          path: "ats/campaigns#email-templates",
          children: [],
        },
        {
          name: "Assign",
          type: "tab",
          key: "campaigns_assign",
          path: "ats/campaigns#bulk-emails",
          children: [],
        },
        {
          name: "Followup Assign",
          type: "tab",
          key: "campaigns_followupassign",
          path: "ats/campaigns#followup-assign",
          children: [],
        },
      ],
    },
    {
      name: "Prospects",
      key: "prospects",
      path: "ats/prospects",
      type: "path",
      children: [
        {
          name: "Prospects",
          type: "tab",
          key: "prospects_propects",
          path: "ats/prospects#prospects",
          children: [],
        },
        {
          name: "My Team prospects",
          type: "tab",
          key: "prospects_myteampropects",
          path: "ats/prospects#myteamprospects",
          children: [],
        },
      ],
    },
    {
      name: "Accounts",
      type: "path",
      key: "accountdetails",
      path: "ats/account-details",
      children: [
        {
          name: "Lead Profile (BDM)",
          type: "tab",
          key: "accountdetails_bdmleadprofile",
          path: "ats/account-details#lead-profile",
          children: [],
        },
        {
          name: "Get Account Details",
          type: "tab",
          key: "accountdetails_getaccountdetails",
          path: "ats/account-details#get-account-details",
          children: [],
        },
        {
          name: "All Accounts",
          type: "tab",
          key: "accountdetails_allaccounts",
          path: "ats/account-details#all-accounts",
          children: [],
        },
      ],
    },
    {
      name: "All Accounts Details",
      type: "path",
      key: "allaccountdetails",
      path: "ats/all-account-details",
      children: [
        {
          name: "Contact",
          type: "tab",
          key: "allaccountdetails_contact",
          path: "ats/all-account-details?account-details=contact",
          children: [],
        },
        {
          name: "Jobs",
          type: "tab",
          key: "allaccountdetails_jobs",
          path: "ats/all-account-details?account-details=jobs",
          children: [],
        },
        {
          name: "Primary Contacts",
          type: "tab",
          key: "allaccountdetails_primarycontacts",
          path: "ats/all-account-details?account-details=primary-contacts",
          children: [],
        },
        {
          name: "Activities",
          type: "tab",
          key: "allaccountdetails_activities",
          path: "ats/all-account-details?account-details=activities",
          children: [],
        },
        {
          name: "Notes",
          type: "tab",
          key: "allaccountdetails_notes",
          path: "ats/all-account-details?account-details=notes",
          children: [],
        },
      ],
    },
    {
      name: "Job Detials",
      type: "path",
      key: "jobsdetailsuiid",
      path: "ats/jobs/job-details",
      children: [
        {
          name: "Info",
          type: "tab",
          key: "jobsdetailsuiid_info",
          path: "ats/jobs/job-details?job-details=info",
          children: [],
        },
        {
          name: "Talent Match",
          type: "tab",
          key: "jobsdetailsuiid_talentmatch",
          path: "ats/jobs/job-details?job-details=talent-match",
          children: [],
        },
        {
          name: "Shortlisted",
          type: "tab",
          key: "jobsdetailsuiid_shortlisted",
          path: "ats/jobs/job-details?job-details=shortlisted",
          children: [],
        },
        {
          name: "Pipeline",
          type: "tab",
          key: "jobsdetailsuiid_pipeline",
          path: "ats/jobs/job-details?job-details=pipeline",
          children: [],
        },
        {
          name: "Submission",
          type: "tab",
          key: "jobsdetailsuiid_submission",
          path: "ats/jobs/job-details?job-details=submission",
          children: [],
        },
        {
          name: "Activities",
          type: "tab",
          key: "jobsdetailsuiid_activities",
          path: "ats/jobs/job-details?job-details=activities",
          children: [],
        },
        {
          name: "Job Campaign",
          type: "tab",
          key: "jobsdetailsuiid_jobcampaign",
          path: "ats/jobs/job-details?job-details=job-campaign",
          children: [],
        },
        {
          name: "Smart Insights",
          type: "tab",
          key: "jobsdetailsuiid_smartinsights",
          path: "ats/jobs/job-details?job-details=smart-insights",
          children: [],
        },
        {
          name: "Query String",
          type: "tab",
          key: "jobsdetailsuiid_querystring",
          path: "ats/jobs/job-details?job-details=query-string",
          children: [],
        },
        {
          name: "Resume Mining",
          type: "tab",
          key: "jobsdetailsuiid_resumemining",
          path: "ats/jobs/job-details?job-details=resume-mining",
          children: [],
        },
        {
          name: "Similar Submission",
          type: "tab",
          key: "jobsdetailsuiid_similarsubmission",
          path: "ats/jobs/job-details?job-details=similar-submission",
          children: [],
        },
        {
          name: "Qualifying Questions",
          type: "tab",
          key: "jobsdetailsuiid_qualifyingquestions",
          path: "ats/jobs/job-details?job-details=qualifying-questions",
          children: [],
        },
        {
          name: "Ai Calls",
          type: "tab",
          key: "jobsdetailsuiid_aicalls",
          path: "ats/jobs/job-details?job-details=ai-calls",
          children: [],
        },
      ],
    },
    {
      name: "Vendors",
      type: "path",
      key: "vendors",
      path: "ats/vendors",
      children: [],
    },
    {
      name: "Jobs",
      type: "path",
      key: "jobs",
      path: "ats/jobs",
      children: [
        {
          name: "All Jobs",
          type: "tab",
          key: "jobs_alljobs",
          path: "ats/jobs#all-jobs",
          children: [],
        },
        {
          name: "My Jobs",
          type: "tab",
          key: "jobs_myjobs",
          path: "ats/jobs#my-jobs",
          children: [],
        },
        {
          name: "Draft Jobs",
          type: "tab",
          key: "jobs_draftjobs",
          path: "ats/jobs#draft-jobs",
          children: [],
        },
        {
          name: "Add New Job Post",
          type: "tab",
          path: "ats/jobs#add-new-job-post",
          key: "jobs_addnewjobpost",
          children: [],
        },
        {
          name: "My Jobs",
          type: "tab",
          path: "ats/jobs#my-jobs",
          key: "jobs_myjobs",
          children: [],
        },
        {
          name: "Job Boards",
          type: "tab",
          key: "jobs_jobboards",
          path: "ats/jobs#job-boards",
          children: [
            {
              name: "Internal DB",
              type: "tab",
              key: "jobs_jobboards_internaldb",
              children: [],
            },
            {
              name: "Career Builder",
              type: "tab",
              key: "jobs_jobboards_careerbuilder",
              children: [],
            },
            {
              name: "Monster",
              type: "tab",
              key: "jobs_jobboards_monster",
              children: [
                // {
                //   name: "Classic Search",
                // },
                // {
                //   name: "Power Search",
                // },
                // {
                //   name: "Monster Search",
                // },
              ],
            },
            {
              name: "Kult Search",
              type: "tab",
              key: "jobs_jobboards_kultsearch",
              children: [],
            },
            {
              name: "Integrated Search",
              type: "tab",
              key: "jobs_jobboards_integratedsearch",
              children: [
                {
                  name: "Internal DB",
                  type: "tab",
                  key: "jobs_jobboards_integratedsearch_Intenaldb",
                },
                {
                  name: "Career Builder",
                  type: "tab",
                  key: "jobs_jobboards_integratedsearch_careerbuilder",
                },
                {
                  name: "Monster",
                  type: "tab",
                  key: "jobs_jobboards_integratedsearch_monster",
                },
              ],
            },
          ],
        },
      ],
    },
    {
      name: "Pipeline Candidates",
      type: "path",
      key: "pipelinecandidates",
      path: "ats/bdm/pipeline-candidates",
      children: [
        {
          name: "Pipeline Candidates",
          type: "tab",
          key: "pipelinecandidates_pipelinecandidates",
          path: "ats/bdm/pipeline-candidates",
          children: [],
        },
      ],
    },
    {
      name: "Client Submissions",
      type: "path",
      key: "clientsubmissions",
      path: "ats/bdm/client-submissions",
      children: [
        {
          name: "Client Submissions",
          type: "tab",
          key: "clientsubmissions_clientsubmissions",
          path: "ats/bdm/client-submissions",
          children: [],
        },
      ],
    },
    {
      name: "Follow up / interview",
      type: "path",
      key: "followupinterviews",
      path: "ats/bdm/followup-interviews",
      children: [
        {
          name: "Interview follow-up",
          type: "tab",
          key: "followupinterviews_interviewfollowup",
          path: "ats/bdm/followup-interviews",
          children: [],
        },
      ],
    },
    {
      name: "Confirmed / Starts (BDM)",
      type: "path",
      key: "confirmedstarts",
      path: "ats/bdm/confirmed-starts",
      children: [
        {
          name: "Confirmed / Starts",
          type: "tab",
          key: "confirmedstarts_confirmedstarts",
          path: "ats/bdm/confirmed-starts",
          children: [],
        },
      ],
    },
    {
      name: "Priority Leads",
      type: "path",
      key: "priorityleads",
      path: "ats/bdm/priority-leads",
      children: [
        {
          name: "Leads",
          type: "tab",
          key: "priorityleads_leads",
          children: [],
        },
        {
          name: "Configuration",
          type: "tab",
          key: "priorityleads_configuration",
          children: [],
        },
      ],
    },
    {
      name: "Leads View(Priority Leads)",
      type: "path",
      key: "priorityleadsview",
      path: "ats/bdm/priority-leads-views",
    },
    {
      name: "Sourcing",
      type: "path",
      key: "applicants",
      path: "/ats/applicants",
      children: [
        {
          name: "All Applicants",
          type: "tab",
          key: "applicants_allapplicants",
          path: "ats/applicants#all-applicants",
          children: [],
        },
        {
          name: "Job Boards",
          type: "tab",
          key: "applicants_jobboards",
          path: "ats/applicants#job-boards",
          children: [
            {
              name: "Internal DB",
              type: "tab",
              key: "applicants_jobboards_internaldb",
              children: [],
            },
            {
              name: "Career Builder",
              type: "tab",
              key: "applicants_jobboards_careerbuilder",
              children: [],
            },
            {
              name: "Monster",
              type: "tab",
              key: "applicants_jobboards_monster",
              children: [
                // {
                //   name: "Classic Search",
                // },
                // {
                //   name: "Power Search",
                // },
                // {
                //   name: "Monster Search",
                // },
              ],
            },
            {
              name: "Kult Search",
              type: "tab",
              key: "applicants_jobboards_kultsearch",
              children: [],
            },
            {
              name: "Integrated Search",
              type: "tab",
              key: "applicants_jobboards_integratedsearch",
              children: [
                {
                  name: "Internal DB",
                  type: "tab",
                  key: "applicants_jobboards_integratedsearch_Intenaldb",
                },
                {
                  name: "Career Builder",
                  type: "tab",
                  key: "applicants_jobboards_integratedsearch_careerbuilder",
                },
                {
                  name: "Monster",
                  type: "tab",
                  key: "applicants_jobboards_integratedsearch_monster",
                },
              ],
            },
          ],
        },
      ],
    },
    {
      name: "Applicant Detials",
      type: "path",
      key: "applicantid",
      path: "ats/applicants/applicant-details",
      children: [
        {
          name: "Snapshot",
          type: "tab",
          key: "applicantid_snapshot",
          path: "ats/applicants/applicant-details",
          children: [],
        },
        {
          name: "Personal Details",
          type: "tab",
          key: "applicantid_personaldetails",
          path: "ats/applicants/applicant-details",
          children: [],
        },
        {
          name: "Profession Details",
          type: "tab",
          key: "applicantid_professionaldetails",
          path: "ats/applicants/applicant-details",
          children: [],
        },
        {
          name: "Employer Details",
          type: "tab",
          key: "applicantid_employerdetails",
          path: "ats/applicants/applicant-details",
          children: [],
        },
        {
          name: "Employment Test Results",
          type: "tab",
          key: "applicantid_employmenttestresults",
          path: "ats/applicants/applicant-details",
          children: [],
        },
        {
          name: "Activities",
          type: "tab",
          key: "applicantid_activities",
          path: "ats/applicants/applicant-details",
          children: [],
        },
      ],
    },
    {
      name: "Campaigns (Recruitment)",
      type: "path",
      key: "recruitmentcampaigns",
      path: "ats/recruitment/campaigns",
      children: [],
    },
    {
      name: "Internal Submissions",
      type: "path",
      key: "recruitmentinternalsubmissions",
      path: "ats/recruitment/internal-submissions",
      children: [
        {
          name: "Internal Submissions",
          type: "tab",
          key: "recruitmentinternalsubmissions_internalsubmissions",
          path: "ats/recruitment/internal-submissions#internal-submissions",
          children: [],
        },
      ],
    },
    {
      name: "Interview follow-up",
      type: "path",
      key: "recruitmentinterviewfollowup",
      path: "ats/recruitment/interview-followup",
      children: [
        {
          name: "Interview Followup",
          type: "tab",
          key: "recruitmentinterviewfollowup_interviewfollowup",
          path: "ats/recruitment/Interview-followup#interview-followup",
          children: [],
        },
      ],
    },
    {
      name: "Jobs (Recruitment)",
      type: "path",
      key: "recruitmentjobs",
      path: "ats/recruitment/Jobs",
      children: [
        {
          name: "All Jobs",
          type: "tab",
          key: "recruitmentjobs_alljobs",
          path: "ats/recruitment/jobs#alljobs",
          children: [],
        },
        {
          name: "My Jobs",
          type: "tab",
          key: "recruitmentjobs_myjobs",
          path: "ats/recruitment/jobs#myjobs",
          children: [],
        },
      ],
    },
    {
      name: "Confirmed / Starts (Recruitment)",
      type: "path",
      key: "recruitmentconfirmedstart",
      path: "ats/recruitment/confirmed-start",
      children: [
        {
          name: "Confirmed/Starts",
          type: "tab",
          key: "recruitmentconfirmedstart_confirmedstarts",
          path: "ats/recruitment/confirmed-start#confirmedstarts",
          children: [],
        },
      ],
    },
    // {
    //   name: "Hotlist",
    //   type: "path",
    //   key: "benchsaleshotlist",
    //   path: "ats/benchsales",
    //   children: [
    //     {
    //       name: "Hotlist",
    //       type: "tab",
    //       key: "benchsaleshotlist",
    //       path: "ats/benchsales/hotlist",
    //       children: [],
    //     },
    //   ],
    // },
    // {
    //   name: "Campaign (Bench Sales)",
    //   type: "path",
    //   key: "benchsalescampaign",
    //   path: "ats/benchsales/campaign",
    //   children: [],
    // },
    // {
    //   name: "Kult Fetch",
    //   type: "path",
    //   key: "benchsaleskultfetch",
    //   path: "ats/benchsales/kultfetch",
    //   children: [
    //     {
    //       name: "Kult Fetch",
    //       type: "tab",
    //       key: "benchsaleskultfetch",
    //       path: "ats/benchsales/kultfetch",
    //       children: [],
    //     },
    //   ],
    // },
    {
      name: "Reports",
      type: "path",
      key: "reports",
      path: "ats/reports",
      children: [
        {
          name: "ATS",
          type: "tab",
          key: "reports_ats",
          path: "ats/reports/ats",
          children: [
            {
              name: "RA Report",
              type: "tab",
              key: "reports_ats_rareport",
              path: "ats/reports/ats#rareport",
              children: [
                {
                  name: "RA Download Sheet",
                  type: "tab",
                  key: "reports_ats_rareport_radownloadsheet",
                  path: "ats/reports/ats/rareport#radownloadsheet",
                  children: [],
                },
                // {
                //   name: "Recruitment Summary Report",
                //   type: "tab",
                //   key:"reports_ats_rareport_recruitmentsummaryreport",
                // }
              ],
            },
            {
              name: "BDM Report",
              type: "tab",
              key: "reports_ats_bdmreport",
              path: "ats/reports/ats#bdmreport",
              children: [
                {
                  name: "BDM Summary Report",
                  type: "tab",
                  key: "reports_ats_bdmreport_bdmsummaryreport",
                  path: "ats/reports/ats/bdmreport#bdmsummaryreport",
                  children: [],
                },
                {
                  name: "BDM Download Sheets",
                  type: "tab",
                  key: "reports_ats_bdmreport_bdmdownloadsheets",
                  path: "ats/reports/ats/bdmreport#bdmdownloadsheets",
                  children: [],
                },
              ],
            },
            {
              name: "Recruitment Report",
              type: "tab",
              key: "reports_ats_recruitmentreport",
              path: "ats/reports/ats#recruitmentreport",
              children: [
                {
                  name: "Recruiter Summary Sheet",
                  type: "tab",
                  key: "reports_ats_recruiterreport_recruitersummarysheet",
                  path: "ats/reports/ats/recruiterreports#recruitersummarysheet",
                },
                {
                  name: "Job Boards Credit Utilization Report",
                  type: "tab",
                  key: "reports_ats_recruiterreport_jobboardcreditutilizationreport",
                  path: "ats/reports/ats/recruiterreports#jobboardcreditutilizationreport",
                },
                {
                  name: "Kult AI Call Summary Report",
                  type: "tab",
                  key: "reports_ats_recruiterreport_kultaicallsummaryreport",
                  path: "ats/reports/ats/recruiterreports#kultaicallsummaryreport",
                },
              ],
            },
            {
              name: "Email Report",
              type: "tab",
              key: "reports_ats_emailreport",
              path: "ats/reports/ats#emailreport",
              children: [
                {
                  name: "Recruiter Email Delivary Report",
                  type: "tab",
                  key: "reports_ats_emailreport_recruiteremaildelivaryreport",
                  path: "ats/reports/ats/emailrreports#recruiteremaildelivaryreport",
                },
              ],
            }
          ],
        },
        {
          name:"Favourite Reports",
          type: "tab",
          key: "fav_reports_ats",
          path: "ats/reports/favouriteReports",
          children: [
            {
              name: "RA Report",
              type: "tab",
              key: "reports_ats_rareport",
              path: "ats/reports/ats#rareport",
              children: [
                {
                  name: "RA Download Sheet",
                  type: "tab",
                  key: "reports_ats_rareport_radownloadsheet",
                  path: "ats/reports/ats/rareport#radownloadsheet",
                  children: [],
                },
                // {
                //   name: "Recruitment Summary Report",
                //   type: "tab",
                //   key:"reports_ats_rareport_recruitmentsummaryreport",
                // }
              ],
            },
            {
              name: "BDM Report",
              type: "tab",
              key: "reports_ats_bdmreport",
              path: "ats/reports/ats#bdmreport",
              children: [
                {
                  name: "BDM Summary Report",
                  type: "tab",
                  key: "reports_ats_bdmreport_bdmsummaryreport",
                  path: "ats/reports/ats/bdmreport#bdmsummaryreport",
                  children: [],
                },
                {
                  name: "BDM Download Sheets",
                  type: "tab",
                  key: "reports_ats_bdmreport_bdmdownloadsheets",
                  path: "ats/reports/ats/bdmreport#bdmdownloadsheets",
                  children: [],
                },
              ],
            },
            {
              name: "Recruitment Report",
              type: "tab",
              key: "reports_ats_recruitmentreport",
              path: "ats/reports/ats#recruitmentreport",
              children: [
                {
                  name: "Recruiter Summary Sheet",
                  type: "tab",
                  key: "reports_ats_recruiterreport_recruitersummarysheet",
                  path: "ats/reports/ats/recruiterreports#recruitersummarysheet",
                },
                {
                  name: "Job Boards Credit Utilization Report",
                  type: "tab",
                  key: "reports_ats_recruiterreport_jobboardcreditutilizationreport",
                  path: "ats/reports/ats/recruiterreports#jobboardcreditutilizationreport",
                },
                {
                  name: "Kult AI Call Summary Report",
                  type: "tab",
                  key: "reports_ats_recruiterreport_kultaicallsummaryreport",
                  path: "ats/reports/ats/recruiterreports#kultaicallsummaryreport",
                },
              ],
            },
            {
              name: "Email Report",
              type: "tab",
              key: "reports_ats_emailreport",
              path: "ats/reports/ats#emailreport",
              children: [
                {
                  name: "Recruiter Email Delivary Report",
                  type: "tab",
                  key: "reports_ats_emailreport_recruiteremaildelivaryreport",
                  path: "ats/reports/ats/emailrreports#recruiteremaildelivaryreport",
                },
              ],
            }
          ],
        },
        // {
        //   name: "WorkForce",
        //   type: "tab",
        //   key: "reports_workforce",
        //   path: "ats/reports#workforce",
        //   children: [],
        // },
      ],
    },
    {
      name: "Marketplace",
      type: "path",
      key: "marketplace",
      path: "ats/marketplace",
      children: [
        {
          name: "Marketplace",
          type: "tab",
          key: "marketplace_marketplace",
          path: "ats/marketplace#marketplace",
          children: [],
        },
      ],
    },
    {
      name: "Marketplace Setup",
      type: "path",
      key: "marketplace_setup",
      path: "ats/marketplace/setup",
      children: [],
    },
    {
      name: "Settings",
      type: "path",
      key: "settings",
      path: "ats/settings",
      children: [
        {
          name: "Company Profile",
          type: "tab",
          key: "settings_companyprofile",
          path: "ats/settings#company-profile",
          children: [
            {
              name: "General Details",
              type: "tab",
              key: "settings_companyprofile_generaldetails",
              children: [],
            },
            {
              name: "Branding",
              type: "tab",
              key: "settings_companyprofile_branding",
              children: [],
            },
            {
              name: "Locale Information",
              type: "tab",
              key: "settings_companyprofile_localinformation",
              children: [],
            },
            {
              name: "Billing & Subscription",
              type: "tab",
              key: "settings_companyprofile_blllingsubscription",
              children: [],
            },
          ],
        },
        {
          name: "Configurations",
          type: "tab",
          key: "settings_configurations",
          path: "ats/settings#configurations",
          children: [
            {
              name: "Automation",
              type: "tab",
              key: "settings_configurations_automation",
              children: [],
            },
            {
              name: "Global Settings",
              type: "tab",
              key: "settings_configurations_globalsettings",
              children: [],
            },
            {
              name: "General Settings",
              type: "tab",
              key: "settings_configurations_generalsettings",
              children: [
                {
                  name: "RA Setting",
                  type: "tab",
                  key: "settings_configurations_generalsettings_rasettings",
                  children: [
                    {
                      name: "Company Settings",
                      type: "tab",
                      key: "settings_configurations_generalsettings_rasettings_companysetting",
                      children: [],
                    },
                    {
                      name: "Google Search Account Settings",
                      key: "settings_configurations_generalsettings_rasettings_googleSetting",
                      type: "tab",
                      children: [],
                    },
                    {
                      name: "Location restriction Settings",
                      key: "settings_configurations_generalsettings_rasettings_locationrestrictionsettings",
                      type: "tab",
                      children: [],
                    },
                    {
                      name: "Location Add Settings",
                      key: "settings_configurations_generalsettings_rasettings_locationaddsettings",
                      type: "tab",
                      children: [],
                    },
                  ],
                },
                {
                  name: "BDM Setting",
                  type: "tab",
                  key: "settings_configurations_generalsettings_bdmsettings",
                   children: [
                    {
                     name: "JobBoard Location Add Settings",
                      key: "settings_configurations_generalsettings_bdmsettings_jobBoardLocationAddSettings",
                      type: "tab",
                      children: [],
                   }
                  ]
                },
                {
                  name: "Recruitement",
                  type: "tab",
                  key: "settings_configurations_generalsettings_recruitement",
                },
                {
                  name: "Bench Sale Setting",
                  type: "tab",
                  key: "settings_configurations_generalsettings_benchsalesetting",
                },
              ],
            },
            {
              name: "Integration",
              type: "tab",
              key: "settings_configurations_integration",
              children: [],
            },
          ],
        },
        {
          name: "Access Control",
          type: "tab",
          key: "settings_accesscontrol",
          path: "ats/settings#access-control",
          children: [
            {
              name: "User Teams",
              type: "tab",
              key: "settings_accesscontrol_userteams",
              children: [],
            },
            {
              name: "Security",
              type: "tab",
              key: "settings_accesscontrol_security",
              children: [
                {
                  name: "Role",
                  type: "tab",
                  key: "settings_accesscontrol_security_role",
                },
                {
                  name: "Module Access",
                  type: "tab",
                  key: "settings_accesscontrol_security_moduleaccess",
                  children: [
                    {
                      name: "ATS",
                      type: "tab",
                      key: "settings_accesscontrol_security_moduleaccess_ats",
                    },
                    {
                      name: "WorkForce",
                      type: "tab",
                      key: "settings_accesscontrol_security_moduleaccess_workforce",
                    },
                  ],
                },
                {
                  name: "Report Access",
                  type: "tab",
                  key: "settings_accesscontrol_security_reportaccess",
                },
                {
                  name: "IP Whitelist",
                  type: "tab",
                  key: "settings_accesscontrol_security_iprestriction",
                },
              ],
            },
          ],
        },
      ],
    },
    {
      name: "Add User",
      type: "path",
      key: "adduser",
      path: "ats/settings/add-user",
      children: [],
    },
     {
      name: "Resume Mining",
      type: "path",
      key: "jobsjobdetailsscheduleresumemining",
      path: "ats/jobs/job-details/schedule-resume-mining",
      children: [],
    },
    {
      name: "Help",
      type: "path",
      key: "help",
      path: "ats/help",
      children: [],
    },
    // {
    //   name: "Company-profile",
    //   type: "path",
    //   path: "ats/settings/company-profile",
    //   children: [
    //     {
    //       name: "View",
    //       type: "tab",
    //       children: [
    //         {
    //           name: "nested-View",
    //           type: "tab",
    //           children: [
    // {
    //   name: "Level 3",
    // },
    // {
    //   name: "child",
    // },
    //           ],
    //         },
    //         {
    //           name: "nested_child",
    //         },
    //       ],
    //     },
    //     {
    //       name: "Edit",
    //       type: "tab",
    //       children: [],
    //     },
    //   ],
    // }
  ];
  const extractCheckedKeys = (items) => {
    let keys = {};
    items.forEach((item) => {
      keys[item.key] = true;
      if (item.children && item.children.length > 0) {
        Object.assign(keys, extractCheckedKeys(item.children));
      }
    });
    return keys;
  };

  return (
    <>
      <div className="grid grid-cols-4 my-4 mx-2">
        <div className="col-span-1">
          <FormFieldSet
            // type="multiSelect"
            type="atsRoles"
            title="Role"
            placeholder="Select"
            // options={[
            //   {
            //     label: "RA Lead",
            //     value: "1",
            //   },
            //   {
            //     label: "RA Manager",
            //     value: "2",
            //   },
            //   {
            //     label: "RA Associate",
            //     value: "3",
            //   },
            // ]}
            value={checkMultiSelected}
            // onChange={setCheckMultiSelected}
            onChange={handleRoleChange}
            showSearch
          />
        </div>
      </div>
      {loading ? (
        <div className="flex items-center justify-center min-h-[60vh]">
          <LogoLoader />
        </div>
      ) : (
        <div>
          {/* <NewTableAdv
            columns={columns}
            rows={mappedRows}
            toolbarRight={{}}
            tdClassName="!py-2"
          /> */}
          <PermissionTable
            data={sampleData}
            onSelectionChange={setSelectedPermissions}
            preselectedModules={originalModuleAccess}
          />
          <div className="flex justify-end mt-5 mx-5">
            <Button title="Save" onClick={handleSave} />
          </div>
        </div>
      )}
    </>
  );
};

export default Ats;
